export default {"src":"/_next/static/media/LOGI.5434325c.svg","height":18,"width":18};